import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import "./Yonetim.css";

function Yonetim() {
  const [managers, setManagers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const { data, error } = await supabase.from("management").select("*");

      if (error) {
        console.error("Yönetim verileri alınırken hata oluştu:", error);
      } else {
        setManagers(data || []);
      }

      setLoading(false);
    };

    fetchData();
  }, []);

  if (loading) return <p>Yükleniyor...</p>;
  if (managers.length === 0) return <p>Yönetim bilgileri bulunamadı.</p>;

  const firstManager = managers[0]; // İlk yönetici
  const otherManagers = managers.slice(1); // Diğer yöneticiler

  return (
    <div className="container section-container yonetim-about">
      <h1 className="yonetim-title">Yönetim</h1>
      <div className="first-manager-container">
        {firstManager && (
          <div key={firstManager.id} className="manager-card">
            <img
              src={firstManager.img_url}
              alt={firstManager.name}
              className="manager-photo"
            />
            <h3 className="manager-name">{firstManager.name}</h3>
            <p className="manager-role">{firstManager.role}</p>
          </div>
        )}
      </div>
      <div className="other-managers-container">
        {otherManagers.map((manager) => (
          <div key={manager.id} className="manager-card">
            <img
              src={manager.img_url}
              alt={manager.name}
              className="manager-photo"
            />
            <h3 className="manager-name">{manager.name}</h3>
            <p className="manager-role">{manager.role}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Yonetim;
